export const products = [
  {
    id: 1,
    name: "메신저 1",
    basePrice: 3000,
    baseFeatures: [
      "수신문서",
      "조직도",
      "대화",
      "쪽지",
      "공지사항",
      "공유폴더",
      "자막뉴스",
      "포스트잇",
      "원격PC연결",
      "관리자기능",
    ],
    options: [
      { name: "근태관리", price: 1000 },
    ],
  },
  {
    id: 2,
    name: "메신저 2",
    basePrice: 4000,
    baseFeatures: [
      "메신저1 포함",
      "게시판",
      "일정관리",
      "설문관리",
    ],
    options: [
      { name: "근태관리", price: 1000 },
    ],
  },
  {
    id: 3,
    name: "고객관리",
    basePrice: 4000,
    baseFeatures: [
      "메신저2 포함",
      "고객관리",
      "업무관리",
      "지식노트",
    ],
    options: [
      { name: "모바일", price: 2000 },
      { name: "전화연동", price: 2000 },
      { name: "근태관리", price: 2000 },
      { name: "장부관리", price: 2000 },
      { name: "SMS (기본요금 / 종량제)", price: null },
    ],
  },
  {
    id: 4,
    name: "그룹웨어",
    basePrice: 6000,
    baseFeatures: [
      "고객관리 포함",
      "근태관리",
      "전자결재",
      "전자문서", 
      "마이링크", 
      "운행기록부", 
      "지출관리", 
      "메일연동", 
      "체크리스트", 
      "업무시간관리", 
      "데이터추출", 
      "파일서버", 
      "외부파일연동", 
      "자원예약관리", 
    ],
    options: [
      { name: "모바일", price: 2000 },
      { name: "전화연동", price: 2000 },
      { name: "장부관리", price: 2000 },
      { name: "서명문서", price: 4000 },
      { name: "생산/재고", price: 4000 },
      { name: "활동관리", price: 4000 },
      { name: "SMS (기본요금 / 종량제)", price: null },
    ],
  },
//   {
//     id: 5,
//     name: "모바일앱만 사용",
//     basePrice: 4000,
//     baseFeatures: [
//       "그룹웨어(PC)와 유사 기능 제공 (자원예약/외부파일연동 제외)",
//       "모바일 전 기능 지원",
//       "문자메시지 기능 및 종량제 사용 가능",
//     ],
//     options: [
//       { name: "전화연동", price: 2000 },
//       { name: "장부관리", price: 2000 },
//       { name: "전자서명문서", price: 4000 },
//       { name: "생산/재고관리", price: 4000 },
//       { name: "업무활동관리", price: 4000 },
//       { name: "문자메시지 (기본요금 & 종량제)", price: null },
//     ],
//   },
];
